module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/2cf8c43c90644782cada89172e0307d0.png";